import keycodes from './keycodes';
// import resizeObserver from './resize-observer';
import { openOverlay, closeOverlay } from '../overlay/animate';
import { getClosest } from '../../utils';

const events = window.PointerEvent ? {
    up: 'pointerup',
    enter: 'pointerenter',
    leave: 'pointerleave',
} : {
    up: 'touchend',
    enter: 'mouseenter',
    leave: 'mouseleave',
};

const menuContainer = document.querySelector('.js-nav');
const menuItems = [...document.querySelectorAll('.js-nav-open-dropdown')];
const dropdownWrapper = document.querySelector('.js-nav-dropdown-wrapper');
const dropdown = document.querySelector('.js-nav-dropdown');
const dropdownSections = [...document.querySelectorAll('.js-nav-dropdown-section')];
const mobileMenu = document.querySelector('.js-mobile-nav');
const mobileMenuBtns = document.querySelectorAll('.js-mobile-nav-btn');
const menuOpenButton = document.querySelector('.js-nav-open-btn');
const menuCloseButton = document.querySelector('.js-nav-close-btn');

let closeDropdownTimeout;
let activeDropdownSectionIndex = -1;
let keydownHandler;
// let resizeHandler;
let mobileMenuOpen = false;

const isMenuVisible = () => {
    const opacity = getComputedStyle(dropdownWrapper).getPropertyValue('opacity');
    return parseFloat(opacity) > 0;
};

const unregisterArrowKeyNavigation = () => {
    if (keydownHandler) {
        menuContainer.removeEventListener('keydown', keydownHandler);
    }

    keydownHandler = undefined;
};

const closeDropdown = () => {
    if (activeDropdownSectionIndex !== -1 && isMenuVisible()) {
        menuContainer.classList.remove('has-visible-dropdown');

        dropdownSections[activeDropdownSectionIndex].setAttribute('aria-hidden', 'true');
        menuItems[activeDropdownSectionIndex].setAttribute('aria-expanded', 'false');

        dropdown.hidden = true;
        dropdownSections[activeDropdownSectionIndex].hidden = true;
        activeDropdownSectionIndex = -1;

        unregisterArrowKeyNavigation();
    }
};

const stopCloseTimeout = () => {
    clearTimeout(closeDropdownTimeout);
};

const startCloseTimeout = () => {
    closeDropdownTimeout = setTimeout(closeDropdown, 50);
};

const registerArrowKeyNavigation = (menuItem, menuSection) => {
    if (keydownHandler !== undefined) unregisterArrowKeyNavigation();

    const links = Array.from(menuSection.querySelectorAll('a'));
    let i = 0;

    links[i].focus();

    keydownHandler = (e) => {
        switch (e.keyCode) {
            case keycodes.TAB:
                menuItem.focus();
                startCloseTimeout();
                break;
            case keycodes.UP:
                e.preventDefault();
                i -= 1;
                if (i < 0) i += links.length;
                links[i].focus();
                break;
            case keycodes.DOWN:
                e.preventDefault();
                i += 1;
                if (i >= links.length) i -= links.length;
                links[i].focus();
                break;
            default:
        }
    };

    menuContainer.addEventListener('keydown', keydownHandler);
};

// const updateMenuAlignment = () => {
//     const winWidth = window.innerWidth;
//     const columnPaddingNormal = parseInt(getComputedStyle(document.documentElement)
//         .getPropertyValue('--columnPaddingNormal'), 10) || 0; // unused
//     const scrollbarWidth = parseInt(getComputedStyle(document.documentElement)
//         .getPropertyValue('--scrollbarWidth'), 10) || 0; // unused
//     let navWidth = 1320;

//     if (winWidth < 1127) navWidth = winWidth - columnPaddingNormal * 2 - scrollbarWidth;

//     const o = navWidth / 4;
//     let a = 0;

//     if (activeDropdownSectionIndex === 1) a = o / 2;
//     else if (activeDropdownSectionIndex > 1) a = o;

//     console.log(a);

//     const xPos = Math.round(a + (winWidth - navWidth) / 2 - scrollbarWidth / 2);

//     dropdown.style.setProperty('--siteMenuTranslateX', `${xPos}px`);
// };

const positionElements = () => {
    if (activeDropdownSectionIndex === -1) return;

    const activeDropdownSection = dropdownSections[activeDropdownSectionIndex];
    const activeMenuItem = menuItems[activeDropdownSectionIndex];

    const documentWidth = document.documentElement.clientWidth;
    const documentCenter = documentWidth / 2;

    const activeMenuItemCenter = activeMenuItem.getBoundingClientRect().left
        + activeMenuItem.offsetWidth / 2;
    const arrowPosition = -1 * (documentCenter - activeMenuItemCenter);

    const chevronWidth = 14;
    const chevronMargin = 10;

    menuContainer.style.setProperty('--siteMenuArrowOffset', `${arrowPosition - ((chevronWidth / 2) + chevronMargin)}px`);

    let width = activeDropdownSection.offsetWidth;
    const height = activeDropdownSection.offsetHeight;

    if (activeDropdownSection.dataset.width !== undefined
        && activeDropdownSection.dataset.width === 'screen') {
        width = menuContainer.offsetWidth;
    }

    dropdown.style.width = `${width}px`;
    dropdown.style.setProperty('--siteMenuHeight', `${height}px`);

    activeDropdownSection.hidden = false;
    activeDropdownSection.setAttribute('aria-hidden', 'false');

    if (activeDropdownSection.dataset.align !== undefined
        && activeDropdownSection.dataset.align === 'edge') {
        dropdown.style.setProperty('--siteMenuTranslateX', '0px');
        return;
    }

    dropdown.style.setProperty('--siteMenuTranslateX', `${activeMenuItemCenter - (width / 2) - ((documentWidth - menuContainer.offsetWidth) / 2)}px`);

    // updateMenuAlignment();
};

const openDropdown = (index, key = false) => {
    if (index !== activeDropdownSectionIndex) {
        if (!isMenuVisible()) {
            menuContainer.classList.add('has-no-transitions');
        }

        activeDropdownSectionIndex = index;

        dropdownSections.forEach((section, i) => {
            section.classList.remove('is-left', 'is-right');
            section.setAttribute('aria-hidden', 'true');
            section.hidden = true;

            if (i < index) {
                section.classList.add('is-left');
            } else if (i > index) {
                section.classList.add('is-right');
            }
        });

        menuItems.forEach((menuItem, i) => {
            menuItem.setAttribute('aria-expanded', i === index ? 'true' : 'false');
        });

        if (key) {
            registerArrowKeyNavigation(menuItems[index], dropdownSections[index]);
        }

        positionElements();

        setTimeout(() => {
            menuContainer.classList.add('has-visible-dropdown');
            menuContainer.classList.remove('has-no-transitions');
            dropdown.hidden = false;
        });
    } else if (!isMenuVisible()) {
        menuContainer.classList.add('has-no-transitions');
    }
};

const toggleDropdown = (index) => {
    if (activeDropdownSectionIndex === index) {
        closeDropdown();
    } else {
        openDropdown(index);
    }
};

const handleMenuClick = (e) => {
    e.stopPropagation();
};

const handleMenuEntered = (e) => {
    if (e.pointerType !== 'touch') stopCloseTimeout();
};

const handleMenuLeft = (e) => {
    if (e.pointerType === 'touch') return;

    if (activeDropdownSectionIndex === 0) {
        const elements = document.elementsFromPoint(e.x, e.y);
        for (let i = 0; i < elements.length; i += 1) {
            if ([...elements[i].classList].includes('pac-container')) return;
        }

        document.querySelectorAll('.pac-container').forEach((el) => { el.style.display = 'none'; });
    }

    startCloseTimeout();
};

const handleMenuTransitionEnd = (e) => {
    if (e.propertyName === 'opacity') {
        dropdown.style.setProperty('pointer-events', isMenuVisible() ? 'auto' : 'none');
    }
};

const handleMenuButtonClick = (e) => {
    e.preventDefault();
    menuContainer.classList.remove('has-no-transitions');
    openOverlay(mobileMenu);
    mobileMenuOpen = true;
};

const handleMenuCloseButtonClick = (e) => {
    if (e) e.preventDefault();
    menuContainer.classList.remove('has-no-transitions');
    closeOverlay(mobileMenu);
    mobileMenuOpen = false;
};

const handleResize = () => {
    positionElements();

    if (mobileMenuOpen
        && window.matchMedia('(min-width: 1200px)').matches) {
        handleMenuCloseButtonClick();
    }
};

const handleBodyClick = () => {
    closeDropdown();
};

const handleEscape = (e) => {
    if (e.key === 'Escape') closeDropdown();
};

const handleTriggerEntered = (e) => {
    if (e.pointerType === 'touch') return;

    const index = menuItems.indexOf(e.currentTarget);

    stopCloseTimeout();

    if (index > -1) openDropdown(index);
};

const handleTriggerLeft = (e) => {
    if (e.pointerType !== 'touch') startCloseTimeout();
};

const handleTriggerClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const index = menuItems.indexOf(e.currentTarget);
    if (index > -1) toggleDropdown(index);
};

const handleTriggerFocused = (e) => {
    stopCloseTimeout();

    const index = menuItems.indexOf(e.currentTarget);

    if (index > -1) openDropdown(index, true);
};

const handleMobileMenuToggleDropdown = (e) => {
    const parent = getClosest(e.currentTarget, '.js-mobile-nav-dropdown');
    parent.setAttribute(
        'aria-expanded',
        `${parent.getAttribute('aria-expanded') !== 'true'}`,
    );
};

const init = () => {
// async function init() {
    if (menuOpenButton) {
        menuOpenButton.addEventListener('click', handleMenuButtonClick);
    }

    if (menuCloseButton) {
        menuCloseButton.addEventListener('click', handleMenuCloseButtonClick);
    }

    dropdown.addEventListener(events.up, handleMenuClick);
    dropdown.addEventListener(events.enter, handleMenuEntered);
    dropdown.addEventListener(events.leave, handleMenuLeft);

    menuContainer.addEventListener('transitionend', handleMenuTransitionEnd);

    if (document.body) {
        document.body.addEventListener(events.up, handleBodyClick);
        document.body.addEventListener('keydown', handleEscape);
    }

    window.addEventListener('resize', handleResize);

    // resizeHandler = await resizeObserver(handleResize);
    // resizeHandler.observe(menuContainer);

    menuItems.forEach((menuItem) => {
        menuItem.addEventListener(events.enter, handleTriggerEntered);
        menuItem.addEventListener(events.leave, handleTriggerLeft);
        menuItem.addEventListener(events.up, handleTriggerClicked);
        menuItem.addEventListener('focusin', handleTriggerFocused);
    });

    mobileMenuBtns.forEach((mobileMenuBtn) => {
        mobileMenuBtn.addEventListener('click', handleMobileMenuToggleDropdown);
    });
};

export default init;
